// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.test.ts`.
// The list of file replacements can be found in `angular.json`.

// Test
export const environment = {
  production: false,
  apiUrl: 'https://api-gateway-test.evnnovator.com/',
  orgId: 'e925731ff7b70acde478591f1327bd1b',
  RazorPayClientId: 'rzp_test_17kYJXxNXqfkfJ',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
